module.exports = function() {
	return new Worker(__webpack_public_path__ + "7c8c955d8d2d3eb23e52.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/_worker-loader@0.8.1@worker-loader!./src/utils/worker.js
// module id = 1450
// module chunks = 129